/** Small white check used inside circular task indicators. */
export function Checkmark() {
  return (
    <svg width="10" height="8" viewBox="0 0 11 9" fill="none">
      <path
        d="M1 4L4 7.5L10 1"
        stroke="white"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
